"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ManagerReportingTable = void 0;
const sortBy_1 = __importDefault(require("lodash/sortBy"));
const react_1 = __importStar(require("react"));
const react_number_format_1 = require("react-number-format");
const react_router_dom_1 = require("react-router-dom");
const react_table_1 = require("react-table");
const configContext_1 = require("../../context/configContext");
const CustomerBooking_1 = require("../../models/CustomerBooking");
const dateUtils = __importStar(require("../../utils/dateUtils"));
const ResourceIconWithColor_1 = require("../resource-icon-with-color/ResourceIconWithColor");
require("./ManagerTables.scss");
/**
 * Table for reporting.
 */
const ManagerReportingTable = (props) => {
    const config = (0, configContext_1.useConfig)();
    const navigate = (0, react_router_dom_1.useNavigate)();
    const columns = (0, react_1.useMemo)(() => {
        const cols = [];
        cols.push({
            Header: "Ressource",
            accessor: (row) => {
                var _a;
                return (react_1.default.createElement(ResourceIconWithColor_1.ResourceIconWithColor, { className: "booking-cell", resource: (_a = row.configResource) !== null && _a !== void 0 ? _a : row.getResourceId() }));
            },
            Footer: "Summe",
        });
        cols.push({
            Header: "Datum",
            accessor: (row) => dateUtils.formatDate(row.start),
        });
        cols.push({
            Header: "Referenz",
            accessor: (row) => react_1.default.createElement("span", { className: "text-nowrap" }, row.reference),
        });
        cols.push({
            Header: "Titel",
            accessor: (row) => row.title,
        });
        cols.push({
            Header: "Organisation",
            accessor: (booking) => {
                if (booking instanceof CustomerBooking_1.CustomerBooking) {
                    return booking.contact.org;
                }
            },
        });
        cols.push({
            Header: "Kontaktperson",
            accessor: (booking) => {
                if (booking instanceof CustomerBooking_1.CustomerBooking) {
                    return booking.contact.name;
                }
            },
        });
        cols.push({
            Header: "Adresse",
            accessor: (booking) => {
                if (booking instanceof CustomerBooking_1.CustomerBooking) {
                    return booking.contact.getAddressBlock({ delimiter: ", " });
                }
            },
        });
        cols.push({
            Header: "E-Mail",
            accessor: (booking) => {
                if (booking instanceof CustomerBooking_1.CustomerBooking) {
                    return booking.contact.email;
                }
            },
        });
        cols.push({
            Header: "Buchungsstatus",
            accessor: (booking) => {
                if (booking instanceof CustomerBooking_1.CustomerBooking) {
                    // Only CustomerBooking has a relevant booking status.
                    return booking.status.nameDe;
                }
                else {
                    return react_1.default.createElement("span", { className: "small italics text-nowrap" }, "kein Kunde");
                }
            },
        });
        function resourcePriceCellValue(row) {
            // Apply discount on resource and on total amount.
            return (row.resourceItem.calcPriceAfterDiscount() *
                row.calcTotals().totalBalanceDueInPercent);
        }
        cols.push({
            Header: "Preis Ressource",
            accessor: (row) => (react_1.default.createElement(NumericFormatForReporting, { className: "text-right d-block", value: resourcePriceCellValue(row) })),
            Footer: (info) => (react_1.default.createElement(NumericFormatForReporting, { className: "text-right d-block", value: info.rows.reduce((accumulator, currentRow) => accumulator + resourcePriceCellValue(currentRow.original), 0) })),
        });
        config
            .getAllAddonTypes({ includeHidden: true, includeMisc: true })
            .forEach((addonType) => {
            function addonPriceCellValue(row) {
                const totals = row.calcTotals();
                let sum = 0;
                if (totals.totalBalanceDue !== 0) {
                    // Calculate the sum of this addon type (without discount).
                    sum = row
                        .getAddonsOfType(addonType)
                        .reduce((accumulator, currentAddon) => {
                        // Add price after discount on addon.
                        return accumulator + currentAddon.calcPriceAfterDiscount();
                    }, sum);
                    // Apply discount on sum.
                    sum *= totals.totalBalanceDueInPercent;
                }
                return sum;
            }
            cols.push({
                Header: addonType,
                accessor: (row) => {
                    return (react_1.default.createElement(NumericFormatForReporting, { className: "text-right d-block", value: addonPriceCellValue(row) }));
                },
                Footer: (info) => (react_1.default.createElement(NumericFormatForReporting, { className: "text-right d-block", value: info.rows.reduce((accumulator, currentRow) => accumulator + addonPriceCellValue(currentRow.original), 0) })),
            });
        });
        function totalCellValue(row) {
            return row.calcTotals().totalBalanceDue;
        }
        cols.push({
            Header: "Total",
            accessor: (row) => (react_1.default.createElement(NumericFormatForReporting, { className: "text-right d-block", value: totalCellValue(row) })),
            Footer: (info) => (react_1.default.createElement(NumericFormatForReporting, { className: "text-right d-block", value: info.rows.reduce((accumulator, currentRow) => accumulator + totalCellValue(currentRow.original), 0) })),
        });
        function outstandingBalanceCellValue(row) {
            return row.calcTotals({ paidByDate: props.paidByDate })
                .outstandingBalance;
        }
        cols.push({
            Header: `Offener Betrag (${dateUtils.formatDate(props.paidByDate)})`,
            accessor: (row) => (react_1.default.createElement(NumericFormatForReporting, { className: "text-right d-block", value: outstandingBalanceCellValue(row) })),
            Footer: (info) => (react_1.default.createElement(NumericFormatForReporting, { className: "text-right d-block", value: info.rows.reduce((accumulator, currentRow) => accumulator + outstandingBalanceCellValue(currentRow.original), 0) })),
        });
        cols.push({
            Header: "Zahlungseingang",
            accessor: (row) => {
                if (row.payments.length > 0) {
                    // Show first payment date.
                    return dateUtils.formatDate(row.payments[0].date);
                }
                else {
                    return "";
                }
            },
        });
        return cols;
    }, [props.paidByDate]);
    // Prepare data.
    let data = [];
    // Sort.
    data = (0, sortBy_1.default)(props.bookings, [(row) => row.start]);
    // Init table.
    const { getTableProps, getTableBodyProps, headerGroups, footerGroups, prepareRow, rows, } = (0, react_table_1.useTable)({
        columns,
        data,
    });
    function handleRowClick(reference) {
        navigate(`/manager/${config.tenantId}/bookings/${reference}/`);
    }
    return (react_1.default.createElement("div", { className: "manager-reporting-table table-responsive" },
        react_1.default.createElement("table", { ...getTableProps(), id: "table", className: "table table-sm sticky-header table-hover" },
            react_1.default.createElement("thead", null, headerGroups.map((headerGroup) => (react_1.default.createElement("tr", { ...headerGroup.getHeaderGroupProps() }, headerGroup.headers.map((column) => (react_1.default.createElement("th", { ...column.getHeaderProps() }, column.render("Header")))))))),
            react_1.default.createElement("tbody", { ...getTableBodyProps() }, rows.map((row, i) => {
                prepareRow(row);
                return (react_1.default.createElement("tr", { ...row.getRowProps(), onClick: () => {
                        if (row.original.reference) {
                            handleRowClick(row.original.reference);
                        }
                    } }, row.cells.map((cell) => {
                    return (react_1.default.createElement("td", { ...cell.getCellProps(), title: cell.value }, cell.render("Cell")));
                })));
            })),
            react_1.default.createElement("tfoot", null, footerGroups.map((footerGroup) => (react_1.default.createElement("tr", { ...footerGroup.getFooterGroupProps() }, footerGroup.headers.map((column) => (react_1.default.createElement("th", { ...column.getFooterProps() }, column.render("Footer"))))))))),
        data.length === 0 && (react_1.default.createElement("div", { className: "text-center text-secondary" }, "Keine Daten"))));
};
exports.ManagerReportingTable = ManagerReportingTable;
const NumericFormatForReporting = (props) => {
    var _a;
    return (react_1.default.createElement(react_number_format_1.NumericFormat, { className: (_a = props.className) !== null && _a !== void 0 ? _a : "", displayType: "text", thousandSeparator: false, decimalSeparator: ".", decimalScale: 2, fixedDecimalScale: true, value: props.value }));
};
